import React, { Component } from 'react'

export default class InputNumber extends Component {

  positive = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (/\+|-/.test(keyValue))
      event.preventDefault();
  }

  render() {
    const {props} = this

    return (
      <input
        {...props}
        type="number"
        className="form-control"
        value={props.value}
        min={0}
        onKeyPress={(event)=>this.positive(event)}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/component/Input.js